<div class="row">
  <div class="columns">
    <h4 class="mos-u-display--inline-block mos-u-spacer--margin-top-sm">Monthly Report - Default Settings</h4>

    <div class="row mos-u-spacer--margin-bottom-md mos-u-display--inline-block mos-u-spacer--margin-top-sm">
      <div class="columns">
        <atlas-checkbox [isChecked]="allCheckbox" checkboxId="all-reports-checkbox" checkboxName="all-reports-checkbox"
          labelTypography="typographyStyles-body-medium" (onChange)="onSelectAllToggle($event)">
          All
        </atlas-checkbox>
      </div>
    </div>

    <div *ngFor="let report of reports$ | async"
      class="row mos-u-spacer--margin-bottom-md mos-u-display--inline-block mos-u-spacer--margin-top-sm">
      <div class="columns">
        <atlas-checkbox [isChecked]="reports[report.key]" [checkboxId]="report.key + '-checkbox'"
          [checkboxName]="report.key + '-checkbox'" labelTypography="typographyStyles-body-medium"
          (onChange)="onSelectReportToggle($event, report.key)">
          {{ report.title }}
        </atlas-checkbox>
      </div>
    </div>
  </div>
</div>

<div class="row ">
  <div class="columns table-data-footer__align-right shrink">
    <atlas-button id="button-tables-data-save" [style]="'strong'" [color]="'brand'" (click)="onSubmit()">Save
    </atlas-button>
    <atlas-button id="button-tables-data-cancel" variant="text" [style]="'no-fill'" [color]="'neutral'"
      (click)="onCancel()">
      Cancel
    </atlas-button>
  </div>
</div>